<template>
  <div
    class="rule-wrapper pb-3 mb-3 w-100 d-flex flex-column align-items-start"
    data-testid="rule"
  >
    <div
      v-if="!isSimpleDetectorRule"
      class="rule-action text-muted no-wrap mt-1 mr-2"
    >
      <span>fraudulent if</span>
    </div>
    <div
      class="rule my-2 d-flex justify-content-between align-items-start w-100"
    >
      <div v-if="!isSimpleDetectorRule" class="d-flex align-items-start">
        <div
          v-if="rule.conditions.all"
          class="d-flex flex-column align-items-start"
        >
          <condition
            v-for="(condition, conditionIndex) in rule.conditions.all"
            :key="conditionIndex"
            :index="conditionIndex"
            :condition="condition"
            :disabled="rule.default"
            :disable-variable="
              !rule.default && isCustomFraudRule && conditionIndex === 0
            "
            :is-last="conditionIndex === rule.conditions.all.length - 1"
            :can-delete="
              rule.conditions.all.length >= 2 &&
              !(isCustomFraudRule && conditionIndex === 0)
            "
            @update="
              (updatedCondition) =>
                onConditionUpdate(updatedCondition, conditionIndex)
            "
            @delete="() => onDeleteCondition(conditionIndex)"
          />
          <button
            v-if="!rule.default"
            class="btn btn-secondary btn-sm"
            data-testid="new-condition-button"
            @click="addAndCondition"
          >
            AND
          </button>
        </div>
      </div>
      <div v-else>
        {{ resolveSimpleDetectorName(rule.conditions.all[0].value[0]) }}
      </div>
      <div class="d-flex align-items-center">
        <button
          v-if="!rule.default"
          class="btn icon-button delete-rule-button"
          data-testid="delete-rule-button"
          @click="deleteRule"
        >
          <font-awesome-icon class="action-icon" icon="trash" />
        </button>
        <i-switch
          v-else
          :value="rule.enabled"
          size="sm"
          type="primary"
          data-testid="default-rule-toggle"
          @input="toggleRule"
        />
      </div>
    </div>
  </div>
</template>

<script>
import set from 'lodash/set';
import Condition from '@/V2/decision-engine/Condition';
import { iSwitch } from '@inscribe/signal';
import { DETECTOR_RESULTS } from '@/constants/requirementVariables';
import { resolveConditionValue } from '@/utils/conditions';

export default {
  components: {
    condition: Condition,
    iSwitch,
  },
  props: {
    rule: {
      type: Object,
      required: true,
    },
    isSimpleDetectorRule: {
      type: Boolean,
      default: false,
    },
    isCustomFraudRule: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    index() {
      return this.$store.state.config.rules.findIndex(
        (rule) => this.rule === rule,
      );
    },
    variables() {
      return this.$store.state.config.rulesSchema.variables;
    },
  },
  methods: {
    addAndCondition() {
      const numConditions = this.rule.conditions.all.length;
      const newRules = set(
        this.$store.state.config.rules,
        [this.index, 'conditions', 'all', numConditions],
        {
          name: null,
          operator: null,
          value: null,
        },
      );

      this.$store.commit('setRules', newRules);
    },
    resolveSimpleDetectorName(value) {
      return resolveConditionValue(DETECTOR_RESULTS, value);
    },
    onConditionUpdate(condition, conditionIndex) {
      if (condition.name === 'sensitive_information_edited') {
        condition.value = true;
      }
      const newRules = set(
        this.$store.state.config.rules,
        [this.index, 'conditions', 'all', conditionIndex],
        condition,
      );
      this.$store.commit('setRules', newRules);
    },
    onDeleteCondition(conditionIndex) {
      const newRules = set(
        this.$store.state.config.rules,
        [this.index, 'conditions', 'all'],
        this.rule.conditions.all.filter(
          (__, index) => index !== conditionIndex,
        ),
      );
      this.$store.commit('setRules', newRules);
    },
    deleteRule() {
      const newRules = this.$store.state.config.rules.filter(
        (__, ruleIndex) => ruleIndex !== this.index,
      );
      this.$store.commit('setRules', newRules);
    },
    toggleRule() {
      if (this.rule.default) {
        const newRules = set(
          this.$store.state.config.rules,
          [this.index, 'enabled'],
          !this.rule.enabled,
        );
        this.$store.commit('setRules', newRules);
      }
    },
  },
};
</script>

<style lang="scss">
.rule-wrapper {
  &:not(:last-of-type) {
    border-bottom: $border-divider;
  }
}
</style>
